import React from 'react'
import styles from './Tag.module.css'

const Tag = ({ selected = false, onClick = () => {}, mode, disabled, children }) => {
  const tagMode = mode === 'dark' ? styles['tag-dark'] : styles.tag
  const classes = selected ? tagMode + ' ' + styles['tag-selected'] : tagMode

  const disabledClasses = mode === 'dark' ? styles['tag-disabled-dark'] : styles['tag-disabled']

  const clickTag = () => {
    if (disabled) return
    onClick()
  }

  return (
    <div className={disabled ? disabledClasses : classes} onClick={clickTag}>
      {children}
    </div>
  )
}

export default Tag
